/**
 * Created by Carsten Bühler
 * User: CBuehler on 17.02.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AmdRequireComponent } from 'plugin/liferay-widgets-react-web';

const ChangeRecordListItem = ({ item, userMeta }) => {
    return item ? (
        <AmdRequireComponent dependencies={[ 'ChangeRecordRenderer/' + item.className ]}>
            {(Renderer) => <Renderer changeRecord={item} userMeta={userMeta || item.userMeta}/>}
        </AmdRequireComponent>
    ) : <div>Keine Datenänderung vorhanden!</div>;
};

ChangeRecordListItem.propTypes = {
    item: PropTypes.object,
    userMeta: PropTypes.object
};

export default ChangeRecordListItem;



// WEBPACK FOOTER //
// ./js/components/ChangeRecordListItem.jsx